var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"vue-tinymce"}},[(_vm.showEditor)?_c('vue-tinymce',{attrs:{"setting":_vm.setting},model:{value:(_vm.editorVlaue),callback:function ($$v) {_vm.editorVlaue=$$v},expression:"editorVlaue"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }